import { Button, Modal, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Button1 } from 'components/Button';
import CusDataGrid from 'components/CusDataGrid';
import CusDrawer from 'components/CusDrawer';
import CusTimeline from 'components/CusTimeline';
import MainCard from 'components/MainCard';
import useMain from 'hooks/useMain';
import { SidebarForm } from 'pages/module/component';
import { SETTING_TYPE } from 'pages/module/constant';
import React, { useState } from 'react';
import { micService } from 'services/mic';
import { handleAlertMessage, handleAsyncCall, toDefaultDateFormat } from 'utils/common';
import { LOG_STATUS } from 'utils/constant';
import { bcTypeCategoryColumns, settingColumns } from './column';
import { settingFields, settingFieldSchema } from './field';
import { useSetting } from './useSetting';
import _ from 'lodash';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxHeight: '70vh',
  overflow: 'scroll',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

const mapLogStatusToColor = (s) => {
  switch (s) {
    case LOG_STATUS.ENABLE:
      return 'success';
    case LOG_STATUS.DISABLE:
      return 'error';
    case LOG_STATUS.NEW:
      return 'primary';
    case LOG_STATUS.UPDATE:
      return 'warning';

    default:
      return 'grey';
  }
};

const SettingLayout = () => {
  const { t, project, useNavigate } = useMain();
  const [openSiderbar, setOpenSidebar] = useState(false);
  const [logData, setLogData] = useState({});
  const [openLog, setOpenLog] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  // const bcTypes = useSelector((state) => state.comModule.bcTypes);
  const handleEdit = (row) => {
    if (_.isEqual(currentSettingType, SETTING_TYPE.GPSHISTORY)) {
      const comboboxObj = _.find(rifdList, ({ value }) => _.isEqual(value, row?.RfidModuleId));

      setSelectedRow({ ...row, RfidModuleId: comboboxObj, IsDefault: row?.IsDefault === 'Y' ? true : false });
    } else {
      setSelectedRow({ ...row, IsDefault: row?.IsDefault === 'Y' ? true : false });
    }
    setOpenSidebar(true);
  };

  const navigate = useNavigate();
  const isNew = _.isEmpty(selectedRow);

  const { currentSettingType, rows, rowKey, bcTypeOptions, companyTypeOptions, rifdList, isLoading, fetchRows } = useSetting();
  const onSubmit = (data) => {
    let mData = {
      ...data,
      IsEnable: 'Y',
      IsDefault: data?.IsDefault ? 'Y' : 'N',
      Sort: Number(data?.Sort || 0)
    };
    let service = isNew ? micService.addSettingData : micService.updateSettingData;
    if (currentSettingType === SETTING_TYPE.GPSHISTORY) {
      service = micService.addUpdateGpsHistory;
      mData = {
        ...data,
        ArrivedHK: data.ArrivedHK ? 1 : 0,
        ArrivedSite: data.ArrivedSite ? 1 : 0,
        LeftFactory: data.LeftFactory ? 1 : 0,
        NotifiedSite: data.NotifiedSite ? 1 : 0,
        RfidModuleId: data?.RfidModuleId?.value,
        RfidtagNo: data?.RfidModuleId?.label
      };
    }
    if (currentSettingType === SETTING_TYPE.VEHICLE) {
      service = micService.addUpdateVehicle;
      mData = data;
    }
    if (currentSettingType === SETTING_TYPE.GPSHISTORY && _.isNull(mData?.CreatedDate)) {
      handleAlertMessage({
        icon: 'error',
        showCancelButton: false,
        title: 'Create date is a required field'
      });
    } else {
      handleAsyncCall({
        service,
        params: {
          projid: project?.ProjId,
          masterType: currentSettingType,
          data: mData
        },
        successCb: (res) => {
          fetchRows();
          setOpenSidebar(false);
        },
        showSuccessAlert: true
      });
    }
  };
  const openAuditLogs = (data) => {
    handleAsyncCall({
      service: micService.getSettingLogs,
      params: {
        projid: project?.ProjId,
        masterType: currentSettingType,
        data
      },
      successCb: (res) => {
        const sData = res.data.map(({ RefId, RefStatus, From, To, CreatedDate }) => {
          const FromContent = _.isNil(From)
            ? ''
            : From.map((obj) => {
                return Object.entries(obj).map(([k, v]) => <Typography key={`${k}-${v}`}>{`${t(k?.toUpperCase())}: ${v}`}</Typography>);
              });

          const ToContent = _.isNil(To)
            ? ''
            : To.map((obj) => {
                return Object.entries(obj).map(([k, v]) => <Typography key={`${k}-${v}`}>{`${t(k?.toUpperCase())}: ${v}`}</Typography>);
              });

          return {
            id: RefId,
            color: mapLogStatusToColor(RefStatus),
            content: (
              <Box>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Typography variant="h4" mb={1}>
                    {RefStatus}
                  </Typography>
                  <Typography variant="h6" mb={1}>
                    {toDefaultDateFormat(CreatedDate, true)}
                  </Typography>
                </Stack>
                {/* <Typography variant="h5">{t('FROM')}</Typography>
                {FromContent}
                <Typography variant="h5">{t('TO')}</Typography> */}
                {ToContent}
              </Box>
            )
          };
        });
        setOpenLog(true);
        setLogData(sData);
      }
    });
  };

  const handleDisable = (row) => {
    handleAlertMessage({
      title: t('CONFIRM_DISABLE'),
      cb: (r) => {
        if (r.isConfirmed) {
          handleAsyncCall({
            service: micService.updateSettingData,
            params: {
              projid: project?.ProjId,
              masterType: currentSettingType,
              data: {
                ...row,
                IsEnable: 'N',
                Sort: Number(row?.Sort || 0)
              }
            },
            successCb: (res) => {
              fetchRows();
              setOpenSidebar(false);
            },
            showSuccessAlert: true
          });
        }
      }
    });
  };
  return (
    <MainCard>
      <CusDataGrid
        cusToolbarComponents={() => (
          <>
            {currentSettingType !== SETTING_TYPE.GPSHISTORY && currentSettingType !== SETTING_TYPE.VEHICLE && (
              <Button1
                text={t('IMPORT')}
                sx={{ ml: [0, 2], mt: [2, 'auto'] }}
                onClick={() => {
                  navigate(`import`);
                }}
              />
            )}
            <Button1
              text={t('BTN_ADD')}
              sx={{ ml: [0, 2], mt: [2, 'auto'] }}
              onClick={() => {
                setSelectedRow({});
                setOpenSidebar(true);
              }}
            />
          </>
        )}
        showExport={false}
        loading={isLoading}
        disableSelectionOnClick
        getRowId={(row) => row[rowKey]}
        rows={rows}
        columns={settingColumns({ t, openSiderbar, currentSettingType, handleEdit, handleDisable, openAuditLogs })}
      />
      <Modal
        open={openLog}
        onClose={() => {
          setLogData([]);
          setOpenLog(false);
        }}
      >
        <Box sx={style}>{_.isEmpty(logData) ? <Typography>{t('NO_RECORDS')}</Typography> : <CusTimeline items={logData} />} </Box>
      </Modal>
      <CusDrawer
        open={openSiderbar}
        onClose={() => {
          setOpenSidebar(false);
        }}
      >
        <SidebarForm
          formData={selectedRow}
          title={isNew ? t('BTN_ADD') : t('EDIT')}
          buttonLabel={t('SUBMIT')}
          handleSubmit={onSubmit}
          fields={settingFields({
            t,
            isNew,
            handleEdit,
            rifdList,
            companyTypeOptions,
            currentSettingType,
            bcTypeOptions
          })}
          schema={settingFieldSchema(currentSettingType)}
        />
      </CusDrawer>
    </MainCard>
  );
};

export default SettingLayout;
